import { mockedSessionAnalysis as aiAssessmentMockedSessionAnalysis } from "./ai-assessment";
import { mockedSessionAnalysis as aiEssentialsMockedSessionAnalysis } from "./ai-essentials";
import { mockedSessionAnalysis as aswbMockedSessionAnalysis } from "./aswb";
import { mockedSessionAnalysis as constructionMockedSessionAnalysis } from "./costruction";
import { mockedSessionAnalysis as databricksMockedSessionAnalysis } from "./databricks";
import { mockedSessionAnalysis as financeMockedSessionAnalysis } from "./finance";
import { mockedSessionAnalysis as healthcareMockedSessionAnalysis } from "./healthcare";
import { mockedSessionAnalysis as mccMockedSessionAnalysis } from "./mcc";
import { mockedSessionAnalysis as officesyncMockedSessionAnalysis } from "./officesync";
import { mockedSessionAnalysis as proethicaMockedSessionAnalysis } from "./proethica";
import { mockedSessionAnalysis as supervisionMockedSessionAnalysis } from "./supervision";
import { mockedSessionAnalysis as techcoreMockedSessionAnalysis } from "./techcore";
import { mockedSessionAnalysis as veterinaryMockedSessionAnalysis } from "./veterniary";

export type DemoExamsType =
	| "healthcare-1"
	| "construction-1"
	| "finance-1"
	| "officesync-1"
	| "techcore-1"
	| "mediquest-1"
	| "aswb-1"
	| "aswb-supervision-certification"
	| "ai-assessment"
	| "genai-engineer"
	| "ai-essentials"
	| "veterinary-medicine"
	| "mcc"
	| "proethica";
export const mockedSessionAnalysis: Record<DemoExamsType, string> = {
	"healthcare-1": healthcareMockedSessionAnalysis,
	"ai-assessment": aiAssessmentMockedSessionAnalysis,
	"construction-1": constructionMockedSessionAnalysis,
	"finance-1": financeMockedSessionAnalysis,
	"officesync-1": officesyncMockedSessionAnalysis,
	"techcore-1": techcoreMockedSessionAnalysis,
	"genai-engineer": databricksMockedSessionAnalysis,
	"mediquest-1": techcoreMockedSessionAnalysis,
	"aswb-1": aswbMockedSessionAnalysis,
	"aswb-supervision-certification": supervisionMockedSessionAnalysis,
	"ai-essentials": aiEssentialsMockedSessionAnalysis,
	"veterinary-medicine": veterinaryMockedSessionAnalysis,
	mcc: mccMockedSessionAnalysis,
	proethica: proethicaMockedSessionAnalysis,
};
